import {GestionArticleDto, IGestionCatalogueWebServiceClient} from "@resources/resources";
import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";

@Injectable()
export class ArticlesAdminResolver implements Resolve<Array<GestionArticleDto>> {

  constructor(private gestionCatalogueWebService: IGestionCatalogueWebServiceClient) {
  }

  resolve(route: ActivatedRouteSnapshot) {
    return this.gestionCatalogueWebService.getArticles();
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/app/pages/cerba/pages/administration/articles/admin.articles.resolver.ts